<template>
	<div class="challenges-completed-block">
		<div class="col-md-4 text-center">
			<SvgChallengesCompleted style="max-width: 200px" />
		</div>
		<div class="col-md-8 text">
			<div>
				{{ t.dashboardAllChallengesCompleted }}
			</div>
		</div>
		<div class="clearfix" />
	</div>
</template>

<script setup>
import { computed } from "vue";
import SvgChallengesCompleted from "@/svg/customer/images/challenges-completed.svg"
import { useStore } from '@/js/stores/index';

const store = useStore()

// Computeds
const t = computed(() => store.translations)
</script>
